<div class="bot-page-main">
  <app-header-bot></app-header-bot>

  <div class="bot-container">

    <div class="page-title-wrapper">
      <h4 class="page-title">CRED Hanuman Bot</h4>
    </div>

    <div class="bot-split-row">

      <div class="bot-box-side-panel">
        <app-hanumanOrderbook></app-hanumanOrderbook>
      </div>
      <div class="bot-box-chart">
        <div class="botChart">
          <app-chart *ngIf="chartStatus" class="trade_chart baseblock_wrapper" [chartData]="chartData"></app-chart>
        </div>
      </div>

      <div class="bot-box-side-panel">
        <app-hanumanOpenPosition></app-hanumanOpenPosition>
      </div>

    </div>

    <div class="bot-middle-row">
      <app-hanumanBotTopGainer></app-hanumanBotTopGainer>
    </div>

    <div class="bot-history">
      <app-HanumanOrderHistory (botSelected)="onBotSelected($event)">
      </app-HanumanOrderHistory>
    </div>

  </div>
</div>